import React, { useContext, useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { InputText } from "primereact/inputtext";
import * as myconst from "../../constants";
import { FloatLabel } from 'primereact/floatlabel';

import {
  generateInstance,
  helperDoc,
  homeBot,
  homeDocumate,
  homeLens,
  homeQmate,
  homeVoice,
  lensAi,
  lensImage,
  imageExpansion,
  lensSmartBack,
  searchMic,
  searchMicActive,
  searchSend,
  similarImage,
  smartBackground,
  uploadIcon,
  uploadImage,
  imageExtender,
  generateEmailIcon,
  generatePostIcon,
  generateIdeaIcon,
  generateArticleIcon,
  generateProductIcon,
  imageCompare,
  generateSentimentAnalysisIcon,
  shopMateIcon,
  homeShopmate,
  shCart,
  shDashboard,
  shChat,
  shInstant,
  edumateIcon,
  insuranceIcon,
  veedaIcon,
} from 'assets/icons';
import { InputTextarea } from 'primereact/inputtextarea';
import VoiceSearch from 'components/VoiceSearch';
import HeaderOne from 'components/HeaderOne';
import { useDispatch, useSelector } from 'react-redux';
import { handleActive, handleAgeRange, handleChannel, handleComplexity, handleConstraints, handleDesiredOutcome, handleIsUserHandler, handleKeyFeatures, handleKeywords, handleLength, handleObjective, handlePlatform, handleProductName, handlePurpose, handleRole, handleRON, handleStyle, handleTone, handleTopic, handleVoiceIds } from 'redux/persistentSlice';
import { handleDocuMatePDF, handleDocuMateRadio, handleDocumateLan, handleHideDocCompRadio, handleHideDocSynRadio, handleLoader, handleSentimentAnalysisPDF, handleVoice, setAudioExtract, setAudioSentiment, setEmailValue, setQmateValue, controlHandlerState, conversationDeleted, setHistoryCalled, handleChatclose, handleChatPreview, resetProductPageQuestion, setIsShowButton } from 'redux/counterSlice';
import { toast } from 'react-toastify';
import { getLanguage } from 'services/coversationService';
import { audio_extraction, voice_interaction_sentiment } from 'services/voiceInteractionService';
import { RootState } from 'redux/store';
import ChatBox from 'components/chat-bot/ChatBox';
import { handleImageDetail, handleLensCounter, handleLensRecommendationImage, setCurrLens } from 'redux/lensSlice';
import { Dropdown } from 'primereact/dropdown';
import { sentimentAnalysis } from 'services/emailService';
import StateContext from 'constants/StateContext';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PlaciFy from 'components/placiFy';
interface Answer {
  ans: {
    response: {
      output_text: string;
    };
    isFirst?: boolean;
  };
}

interface Query {
  que: string;
  isUser: boolean;
}
interface StateContextType {
  setAnswer: React.Dispatch<React.SetStateAction<Answer[]>>;
  setUserQuery: React.Dispatch<React.SetStateAction<Query[]>>;
  setCurrent: React.Dispatch<React.SetStateAction<string | null>>;
  setFileLanguage: React.Dispatch<React.SetStateAction<string>>;
  setHover: React.Dispatch<React.SetStateAction<string | null>>;
  handleNewChatButton: () => void;
}

const Home = ({ overlayLens, oh }: any) => {
  const { setAnswer, setUserQuery, setCurrent, setHover, handleNewChatButton, setFileLanguage } = useContext<StateContextType>(StateContext);
  // const overlayLens: any = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileInputRef: any = useRef(null);
  const fileSentimentInputRef: any = useRef(null);
  const voiceInputRef: any = useRef(null);
  const lensInputRef: any = useRef(null);
  const inputRef: any = useRef(null);
  const inputEmailRef: any = useRef(null);
  const [qmate, setQmate] = useState<string>('');
  const [emailGen, setEmailGen] = useState<string>('');
  const [isKeyDown, setIsKeyDown] = useState(false);
  const inputbox: any = document.querySelector('.input-box');
  const sendButton: any = document.querySelector('#send-button');
  let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
  const currLens = useSelector((state: any) => state.lens.currLens);
  const currentActive = useSelector((state: any) => state.persistent.currentActive);
  const roleDropdown = useSelector((state: any) => state.persistent.roleDropdown);
  const toneDropdown = useSelector((state: any) => state.persistent.toneDropdown);
  const styleDropdown = useSelector((state: any) => state.persistent.styleDropdown);
  const lengthDropdown = useSelector((state: any) => state.persistent.lengthDropdown);
  const complexityDropdown = useSelector((state: any) => state.persistent.complexityDropdown);
  const ageRangeDropdown = useSelector((state: any) => state.persistent.ageRangeDropdown);
  const objectiveDropdown = useSelector((state: any) => state.persistent.objectiveDropdown);
  const platformDropdown = useSelector((state: any) => state.persistent.platformDropdown);
  const channelDropdown = useSelector((state: any) => state.persistent.channelDropdown);
  const desiredOutcomeDropDown = useSelector((state: any) => state.persistent.desiredOutcomeDropDown);
  const keywords = useSelector((state: any) => state.persistent.keywords);
  const key_features = useSelector((state: any) => state.persistent.key_features);
  const product_name = useSelector((state: any) => state.persistent.product_name);
  const purpose = useSelector((state: any) => state.persistent.purpose);
  const topic = useSelector((state: any) => state.persistent.topic);
  const constraintsDropdown = useSelector((state: any) => state.persistent.constraintsDropdown);
  const RON = useSelector((state: any) => state.persistent.RON);
  const qmateValue = useSelector((state: any) => state.counter.qmateValue);
  const VoiceSearchFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.voiceSearch];
  const location = useLocation();
  const stateWise = location.state || {};
  const [placiFyOpen, setPlaciFyOpen] = useState(false);
  const placiFyRef = useRef<{ disconnect: () => void; }>(null);
  // dispatch(controlHandlerState(""));
  const connectorsListRole = [
    { name: "Sales Executive" },
    { name: "Software Engineer" },
    { name: "Product Manager" },
    { name: "Customer Support Specialist" },
    { name: "Marketing Manager" },
    { name: "Human Resources Manager" },
    { name: "Finance Analyst" },
    { name: "Operations Manager" },
    { name: "Data Scientist" },
    { name: "Graphic Designer" },
    { name: "Other" },
  ];
  const connectorsListTone = [
    { name: "Casual" },
    { name: "Friendly" },
    { name: "Formal" },
    { name: "Professional" },
  ];
  const connectorsListStyle = [
    { name: "Concise" },
    { name: "Neutral" },
    { name: "Polite" },
    { name: "Persuasive" },
  ];
  const connectorsListLength = [
    { name: "Short" },
    { name: "Medium" },
    { name: "Long" }
  ];
  const connectorsListComplexity = [
    { name: "Simple" },
    { name: "Moderate" },
    { name: "Detailed" }
  ];
  const connectorsListAgeRange = [
    { name: "15-20" },
    { name: "20-25" },
    { name: "25-30" },
  ];
  const connectorsListObjective = [
    { name: "Marketing" },
    { name: "Campaign" },
    { name: "Product Innovation" },
    { name: "Content Creation" },
    { name: "Problem Solving" },
  ];
  const connectorsListPlatform = [
    { name: "Twitter" },
    // { name: "Instagram" },
    { name: "Facebook" },
    { name: "Linkedin" },
  ];
  const connectorsListChannel = [
    { name: "Online store" },
    { name: "E-commerce website" },
    { name: "Retail store" },
  ];
  const connectorsListDesiredOutcome = [
    { name: 1 },
    { name: 2 },
    { name: 3 },
    { name: 4 },
    { name: 5 },
  ];
  const connectorsListConstraints = [
    { name: "Budget" },
    { name: "Compatibility" },
    { name: "User Privacy" },
    { name: "Technology" },
  ];
  const voiceSearch = VoiceSearch(
    setIsKeyDown,
    inputbox,
    sendButton,
    setQmate,
  );
  const voiceSearchGen = VoiceSearch(
    setIsKeyDown,
    inputbox,
    sendButton,
    setEmailGen,
  );

  //**Qmate**
  const handleStartListening = voiceSearch.handleStartListening;
  const handleStartListeningGeneration = voiceSearchGen.handleStartListening;
  const defaultQuestions = JSON.parse(localStorage.getItem("default_questions") as any);

  const handleVoiceIconClicked = () => {
    setIsKeyDown(true);
    setQmate('Listening...');
    handleStartListening();
  };
  const handleVoiceIconClickedGeneration = () => {
    setIsKeyDown(true);
    setEmailGen('Listening...');
    // dispatch(setQmateValue('Listening...'));
    if (inputbox) {
      inputbox.setAttribute('disabled', true);
    }
    if (sendButton) {
      sendButton.setAttribute('disabled', true);
    }
    handleStartListeningGeneration();
  };
  //Handle Search input box
  const handleInputChange = (e: any) => {
    setQmate(e.target.value);
  };
  const handleInputChangeEmail = (e: any) => {
    setEmailGen(e.target.value);
  };
  const handleSendQueryButton = () => {
    const trimmedQmate = qmate.trim();
    if (trimmedQmate !== "") {
      dispatch(setQmateValue(trimmedQmate));
      navigate("/chat-bot/new-chat");
    }
  };
  const handleSendQueryButtonEmail = () => {
    dispatch(setEmailValue(emailGen.trim()));
    if (emailGen.trim() !== "") {
      if (currentActive === "generateEmail") {
        navigate("/generate-email/new-email");
      } else if (currentActive === "generateIdea") {
        navigate("/generate-idea/new-idea");
      } else if (currentActive === "generateProduct") {
        navigate("/generate-product/new-product");
      } else if (currentActive === "generateArticle") {
        navigate("/generate-article/new-article");
      } else if (currentActive === "generatePost") {
        navigate("/generate-post/new-post");
      }
    }
  };
  const handleEnterPressed = (e: any) => {
    const trimmedQmate = qmate.trim();
    if (e.key === 'Enter') {
      if (trimmedQmate === "") {
        e.preventDefault();
      } else {
        handleSendQueryButton();
      }
    }
  };
  const handleEnterPressedEmail = (e: any) => {
    const trimmedGeneration = emailGen.trim();
    if (e.key === 'Enter') {
      if (trimmedGeneration === "") {
        e.preventDefault();
      } else {
        handleSendQueryButtonEmail();
      }
    }
  };
  const handleDefaultQuestions = (str: string) => {
    dispatch(setQmateValue(str));
    navigate("/chat-bot/new-chat");
  };
  const activeArray = ["generateEmail", "generateIdea", "generateProduct", "generateArticle", "generatePost", "sentimentAnalysis"];
  useEffect(() => {
    const temp = document.getElementById('qmate');
    if (currentActive === "qmate" && qmate !== "" && qmate !== 'Listening...') {
      temp?.focus();
    }
  }, [qmate]);
  useEffect(() => {
    const temp = document.getElementById('emailgen');
    if (activeArray?.includes(currentActive) && emailGen !== "" && emailGen !== 'Listening...') {
      temp?.focus();
    }
  }, [emailGen]);

  useEffect(() => {
    handleNewChatButton();
    dispatch(conversationDeleted(false));
    dispatch(setHistoryCalled(true));
    dispatch(handleDocuMateRadio(''));
    setCurrent(null);
    setHover(null);
    setAnswer([]);
    setUserQuery([]);
  }, []);

  // **Documate**
  const handleButtonClick = () => {
    // Trigger the file input when the button is clicked
    fileInputRef.current.click();
  };
  const handleBrowseFiles = async (e: any) => {
    const file = e?.target?.files[0];
    dispatch(handleHideDocCompRadio(false));
    dispatch(handleHideDocSynRadio(false));
    if (file && file?.type === "application/pdf") {
      const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
      if (file?.size > maxSize) {
        toast.error('File size should not be more than 10 MB', {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        fileInputRef.current.value = null;
        return;
      }
      dispatch(handleLoader(true));
      const base64Code: any = await myconst.fileToBase64(file);
      const correctBase64 = await myconst.manipulateBase64Data(base64Code);
      const body = {
        query: "",
        user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
        file_data: correctBase64,
        file_name: file.name
      };
      try {
        const { result, error } = await getLanguage(body);
        if (error) {
          throw error;
        }
        if (result?.error) {
          throw result.error;
        }
        setFileLanguage(result.PDF_Language);
        // dispatch(handleDocumateLan(result.PDF_Language));
        const temp: any = {};
        temp.pdf = correctBase64;
        temp.name = file.name;
        dispatch(handleDocuMatePDF(temp));
        dispatch(handleLoader(false));
        navigate("/document-processing/new-chat");
        dispatch(handleDocuMateRadio('Q&A'));
      } catch (error: any) {
        if (error === "Please upload a text document;scanned documents and image only PDFs won't be processed.") {
          toast.error("Please upload a text document. Blank documents, scanned documents, and image only PDFs cannot be processed", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else if (error === "EOF marker not found") {
          toast.error("The file is corrupted or incomplete and cannot be processed. Please upload a valid file", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else if (error === "File has not been decrypted") {
          toast.error("The uploaded file is encrypted or password-protected. Please decrypt it and try again", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else {
          toast.error(error, {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        }
      }
      // setInputFile(e.target.files[0])
      fileInputRef.current.value = null;
    } else {
      toast.error("File is not supported", {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
      fileInputRef.current.value = null;
    }
  };

  const handleSentimentAnalysisClick = () => {
    fileSentimentInputRef.current.click();
  };

  const handleSentimentBrowseFiles = async (e: any) => {
    const file = e?.target?.files[0];
    if (!file) {
      return;
    }
    if (file && file?.type === "application/pdf") {
      const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
      if (file?.size > maxSize) {
        toast.error('File size should not be more than 10 MB', {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        fileSentimentInputRef.current.value = null;
        return;
      }
      dispatch(handleLoader(true));
      const body = {
        user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
        file1: file
      };
      try {
        const { result, error } = await sentimentAnalysis(body);
        if (error) {
          throw error;
        }
        if (result?.error) {
          throw result.error;
        }
        const invalidRating = result?.sentiment.some((data: any) => {
          const [ratingValue] = data.Rating.split('/').map(Number);
          return ratingValue > 5;
        });

        if (invalidRating) {
          dispatch(handleLoader(false));
          toast.error("One or more reviews contain ratings greater than 5. Please ensure all ratings are 5 or below before uploading", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
        } else {
          dispatch(handleSentimentAnalysisPDF(result));
          navigate("/sentiment-analysis/new-sentiment");
        }
        fileSentimentInputRef.current.value = null;
      } catch (error: any) {
        if (error === "The file is corrupted and cannot be processed.") {
          toast.error("The file is corrupted or incomplete and cannot be processed. Please upload a valid file", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else if (error === "Please upload a text document; scanned documents and image-only PDFs won't be processed.") {
          toast.error("Please upload a text document. Blank documents, scanned documents, and image only PDFs cannot be processed", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else if (error === "File has not been decrypted") {
          toast.error("The uploaded file is encrypted or password-protected. Please decrypt it and try again", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else if (error === "Please upload a document must contain at least one 'rating/review' section.") {
          toast.error("Please upload a document that contains at least one 'Rating' or 'Review' section", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        } else {
          toast.error(error, {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          dispatch(handleLoader(false));
        }
      } finally {
        fileSentimentInputRef.current.value = null;
      }
      // dispatch(handleSentimentAnalysisPDF(e?.target?.files[0]))
    } else {
      toast.error("File is not supported", {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
      fileSentimentInputRef.current.value = null;
    }
  };

  //  **Voice**
  const handleVoiceToggle = () => {
    // Trigger the file input when the button is clicked
    voiceInputRef.current.click();
  };
  const postSentiment = async (body: any, id: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await voice_interaction_sentiment(body);
      if (error) {
        throw error;
      }
      if (result?.error) {
        throw result.error;
      }
      dispatch(setAudioSentiment(result));
      dispatch(handleVoice(true));
      navigate(`/voice/${id}`);
      dispatch(handleLoader(false));
      dispatch(handleVoiceIds([]));
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  };

  const handleVoiceChange = async (event: any) => {
    const file = event.target.files[0];
    const size = Number(event?.target?.files[0]?.size / 1048576);
    if (file) {
      if (size < 5 && file.size > 0) {
        if (file && myconst.audioTypes.includes(file.type)) {
          dispatch(handleLoader(true));
          const base64Code: any = await myconst.fileToBase64(file);
          const correctBase64 = await myconst.manipulateBase64Data(base64Code);
          const body: any = {};
          body.user_name = localStorage.getItem("username");
          body.file_data = correctBase64;
          body.file_name = myconst.fileExtChange(file);
          body.audio_file_name = file.name;
          try {
            const { result, error } = await audio_extraction(body);
            if (error) {
              throw error;
            }
            if (result?.error) {
              throw result.error;
            }
            dispatch(setAudioExtract(result));
            const data: any = {};
            data.user_name = localStorage.getItem("username");
            data.audio_id = result.audio_id;
            data.file_name = result.file_name;
            data.file_data = result.encoded_text_value;
            data.audio_file_name = file.name;
            await postSentiment(data, result.audio_id);
            voiceInputRef.current.value = null;
          } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
              style: {
                backgroundColor: '#F1F1F1', // Grey background
              }
            });
          }
        } else {
          voiceInputRef.current.value = null;
          toast.error("File is not supported", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
        }
      } else {
        voiceInputRef.current.value = null;
        toast.error("File size should not be more than 5 MB", {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      }
    }
  };

  //  **lens**
  const handleLensToggle = () => {
    // Trigger the file input when the button is clicked
    lensInputRef.current.click();
  };
  const handleLensChange = async (event: any) => {
    const file = event.target.files[0];
    const size = Number(event?.target?.files[0]?.size / 1048576);
    const imageDetailObject: { name: string, type: string; } = {
      name: '',
      type: ''
    };
    imageDetailObject.name = file?.name;
    imageDetailObject.type = file?.type;
    if (file) {
      if (size < 10 && file.size > 0) {
        if (file && myconst.imageTypes.includes(file.type)) {
          const base64Code: any = await myconst.fileToBase64(file);
          const correctBase64 = await myconst.manipulateBase64Data(base64Code);
          dispatch(handleLensRecommendationImage(correctBase64));
          dispatch(handleImageDetail(imageDetailObject));
          dispatch(handleLensCounter());
          // switch (currLens) {
          //   case "Similar Image":
          //     navigate("/lens/similar-image");
          //     break;
          //   case "Smart Background":
          //     navigate("/lens/smart-background");
          //     break;
          //   case "Generate Instance":
          //     navigate("/lens/generate-instance");
          //     break;
          // }
          if (currLens === "Similar Images") {
            navigate("/lens/similar-image");
          } else if (currLens === "Smart Background") {
            navigate("/lens/smart-background");
          } else if (currLens === "Generate Instance") {
            navigate("/lens/generate-instance");
          } else if (currLens === "Image Extender") {
            navigate("/lens/image-extender");
          } else if (currLens === "Image Comparison") {
            navigate("/lens/image-comparison");
          }
          event.target.value = null;
        } else {
          toast.error("File is not supported", {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
          lensInputRef.current.value = "";
        }
      } else {
        toast.error("File size should not be more than 10 MB", {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        lensInputRef.current.value = "";
      }
    }
  };
  const handleCurrentLens = (value: string) => {
    dispatch(setCurrLens(value));
    overlayLens.current.hide();
  };

  const handleCompareImage = async (value: string) => {
    await dispatch(setCurrLens(value));
    navigate("/lens/image-comparison");
  };

  const handleCurrentLensImage = () => {
    switch (currLens) {
      case "Similar Images":
        return similarImage;
      case "Smart Background":
        return smartBackground;
      case "Generate Instance":
        return generateInstance;
      case "Image Extender":
        return imageExtender;
      case "Image Comparison":
        return imageCompare;
      default:
        return "";
    }
  };
  const permissionLocal: any = localStorage.getItem("permissions");
  const permission: any = JSON.parse(permissionLocal);
  const q_aManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.q_a);
  const voiceManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.voice);
  const botManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.bot);
  const uploadDocManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.uploadDoc);
  const imageExtenderObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.imageExtender);
  const similarImagesObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.similarImages);
  const smartBackgroundObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.smartBackground);
  const imageComparisionObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.imageComparison);
  const generateInstanceObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.generateInstance);
  const productDesGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.productDesGeneration);
  const sentimentAnalysisObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.sentimentAnalysis);
  const postGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.postGeneration);
  const ideaGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.ideaGeneration);
  const emailGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.emailGeneration);
  const articleGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.articleGeneration);
  const lensObject = [imageExtenderObject?.permissions, similarImagesObject?.permissions, smartBackgroundObject?.permissions, generateInstanceObject?.permissions, imageComparisionObject?.permissions].some((a) => a === true);
  const booleanArray = [q_aManagementObject?.permissions, uploadDocManagementObject?.permissions, voiceManagementObject?.permissions, lensObject]?.filter(value => value)?.length;
  const booleanArray2 = [q_aManagementObject?.permissions, uploadDocManagementObject?.permissions, voiceManagementObject?.permissions, botManagementObject?.permissions, lensObject]?.filter(value => value)?.length;
  const marketObjectFilter = [emailGenerationObject?.permissions, postGenerationObject?.permissions, articleGenerationObject?.permissions, ideaGenerationObject?.permissions, productDesGenerationObject?.permissions, sentimentAnalysisObject?.permissions].some((a) => a === true);
  const marketObjectFilterLength = [emailGenerationObject?.permissions, postGenerationObject?.permissions, articleGenerationObject?.permissions, ideaGenerationObject?.permissions, productDesGenerationObject?.permissions, sentimentAnalysisObject?.permissions].filter((a) => a === true);

  const handleSingleFunction = () => {
    if (booleanArray2 === 1 && currentActive === '') {
      if (botManagementObject?.permissions) {
        dispatch(handleActive("shopmate"));
        dispatch(handleRON('shopmate'));
        dispatch(setCurrLens(""));
      } else if (q_aManagementObject?.permissions) {
        dispatch(handleActive("qmate"));
        dispatch(setCurrLens(""));
      } else if (uploadDocManagementObject?.permissions) {
        dispatch(handleActive("documate"));
        dispatch(setCurrLens(""));
      } else if (voiceManagementObject?.permissions) {
        dispatch(handleActive("voice"));
        dispatch(setCurrLens(""));
      } else if (botManagementObject?.permissions) {
        dispatch(handleActive("shopmate"));
        dispatch(handleRON('shopmate'));
        dispatch(setCurrLens(""));
      } else if (lensObject) {
        dispatch(handleActive("lens"));
        dispatch(setCurrLens(""));
      }
    }
  };
  const handleTemp = () => {
    if (marketObjectFilter && !['generateEmail', 'generatePost', 'generateArticle', 'generateIdea', 'generateProduct', 'sentimentAnalysis'].includes(currentActive) && currentActive === '') {
      if (q_aManagementObject?.permissions) {
        dispatch(handleActive("qmate"));
        dispatch(handleRON('product'));
        dispatch(setCurrLens(""));
      } else if (uploadDocManagementObject?.permissions) {
        dispatch(handleActive("documate"));
        dispatch(handleRON('product'));
        dispatch(setCurrLens(""));
      } else if (voiceManagementObject?.permissions) {
        dispatch(handleActive("voice"));
        dispatch(handleRON('product'));
        dispatch(setCurrLens(""));
      } else if (botManagementObject?.permissions) {
        dispatch(handleActive("shopmate"));
        dispatch(handleRON('shopmate'));
        dispatch(setCurrLens(""));
      } else if (lensObject) {
        dispatch(handleActive("lens"));
        dispatch(handleRON('product'));
        dispatch(setCurrLens(""));
      }
    } else if (Object.keys(stateWise).length > 0) {
      dispatch(handleActive(stateWise.current_active));
      dispatch(handleRON(stateWise.ron));
      dispatch(setCurrLens(stateWise.curr_lens));
    }
  };
  const solutions = () => {
    if (booleanArray === 1 && RON === 'product') {
      return 'Solution';
    } else if (RON === 'shopmate') {
      return 'Solution';
    } else if (RON === 'solution' && marketObjectFilterLength.length === 1) {
      return 'Solution';
    } else {
      return 'Solutions';
    }
  };
  useEffect(() => {
    handleTemp();
    handleSingleFunction();
    dispatch(handleTopic(""));
    dispatch(handlePurpose(""));
    dispatch(handleProductName(""));
    dispatch(handleConstraints({ name: "Budget" }));
    dispatch(handleKeyFeatures(""));
    dispatch(handleKeywords(""));
    dispatch(handleDesiredOutcome({ name: "1" }));
    dispatch(handleChannel({ name: "Online Store" }));
    dispatch(handlePlatform({ name: "Twitter" }));
    dispatch(handleObjective({ name: "Marketing" }));
    dispatch(handleAgeRange({ name: "15-20" }));
    dispatch(handleComplexity({ name: 'Simple' }));
    dispatch(handleLength({ name: 'Short' }));
    dispatch(handleStyle({ name: 'Concise' }));
    dispatch(handleTone({ name: 'Casual' }));
    dispatch(handleRole({ name: 'Sales Executive' }));
  }, []);

  useEffect(() => {
    if (currentActive === "generateEmail" || currentActive === "generatePost" || currentActive === "generateArticle" || currentActive === "generateIdea" || currentActive === "generateProduct") {
      setEmailGen("");
      dispatch(handleTopic(""));
      dispatch(handlePurpose(""));
      dispatch(handleProductName(""));
      dispatch(handleConstraints({ name: "Budget" }));
      dispatch(handleKeyFeatures(""));
      dispatch(handleKeywords(""));
      dispatch(handleDesiredOutcome({ name: 1 }));
      dispatch(handleChannel({ name: "Online store" }));
      dispatch(handlePlatform({ name: "Twitter" }));
      dispatch(handleObjective({ name: "Marketing" }));
      dispatch(handleAgeRange({ name: "15-20" }));
      dispatch(handleComplexity({ name: 'Simple' }));
      dispatch(handleLength({ name: 'Short' }));
      dispatch(handleStyle({ name: 'Concise' }));
      dispatch(handleTone({ name: 'Casual' }));
      dispatch(handleRole({ name: 'Sales Executive' }));
    }
  }, [currentActive]);

  const imageSrc = () => {
    switch (currentActive) {
      case 'qmate':
        return homeQmate;
      case 'documate':
        return homeDocumate;
      case 'voice':
        return homeVoice;
      // case 'shopmate':
      //   return homeShopmate;
      case 'lens':
        return homeLens;
      default:
        return "";
    }
  };

  const imageSrcName = () => {
    switch (currentActive) {
      case 'qmate':
        return (<div className='right-menu-desc'>
          <strong>QMate!</strong>
          <p>Get instant answers from your enterprise data.</p>
        </div>);
      case 'documate':
        return (<div className='right-menu-desc'>
          <strong>DocuMate!</strong>
          <p>Discover the intelligence within your documents.</p>
        </div>);
      case 'voice':
        return (<div className='right-menu-desc'>
          <strong>Voice!</strong>
          <p>AI-powered voice analytics.</p>
        </div>);
      // case 'shopmate':
      //   return (<div className='right-menu-desc'>
      //     <strong>Shopmate!</strong>
      //     <p>Elevate customer service with Ron! ShopMate!</p>
      //   </div>);
      case 'lens':
        return (<div className='right-menu-desc'>
          <strong>Lens!</strong>
          <p>Revolutionize Your Photo Editing Experience.</p>
        </div>);
      default:
        return "";
    }
  };

  useEffect(() => {
    const permissionObjects = [
      imageExtenderObject,
      similarImagesObject,
      smartBackgroundObject,
      generateInstanceObject,
      imageComparisionObject
    ];

    const truePermissionObjects = permissionObjects.filter(obj => obj?.permissions);

    if (truePermissionObjects.length === 1) {
      dispatch(setCurrLens(truePermissionObjects[0]?.label));
    }
  }, [myconst, currentActive]);
  const permissionObjects = [
    imageExtenderObject,
    similarImagesObject,
    smartBackgroundObject,
    generateInstanceObject,
    imageComparisionObject,
  ];
  const truePermissionObjects = permissionObjects.filter(obj => obj?.permissions);
  const handleChatBot = () => {
    dispatch(handleChatPreview());
    dispatch(resetProductPageQuestion());
    dispatch(setIsShowButton());
  };
  const handleFinalFunction = () => {
    if (RON === "product" && booleanArray2 !== 1) {
      return (<ul className='home-content-list'>
        {q_aManagementObject?.permissions &&
          <li>
            <Link to="#" className={currentActive === 'qmate' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("qmate")); dispatch(setCurrLens("")); }}>
              <img src={homeQmate} alt='qmate-icon' />
            </Link>
            <span>QMate!</span>
            <p>Get instant answers from your enterprise data.</p>
          </li>
        }
        {uploadDocManagementObject?.permissions &&
          <li>
            <Link to="#" className={currentActive === 'documate' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("documate")); dispatch(setCurrLens("")); }}>
              <img src={homeDocumate} alt='documate-icon' />
            </Link>
            <span>DocuMate!</span>
            <p>Discover the intelligence within your documents.</p>
          </li>
        }
        {voiceManagementObject?.permissions &&
          <li>
            <Link to="#" className={currentActive === 'voice' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("voice")); dispatch(setCurrLens("")); }}>
              <img src={homeVoice} alt='voice-icon' />
            </Link>
            <span>Voice!</span>
            <p>AI-powered voice analytics.</p>
          </li>
        }
        {/* {botManagementObject?.permissions &&
          <li>
            <Link to="#" className={currentActive === 'bot' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("bot")); dispatch(setCurrLens("")); }}>
              <img src={homeBot} alt='bot-icon' />
            </Link>
            <span>Bot!</span>
            <p>Elevate customer service with Ron! Bot!</p>
          </li>
        } */}
        {lensObject &&
          <li>
            <Link to={truePermissionObjects.length === 1 && imageComparisionObject?.permissions ? "/lens/image-comparison" : "#"} className={currentActive === 'lens' ? 'home-content-active' : ""}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(handleActive("lens"));
                if (truePermissionObjects.length > 1) {
                  overlayLens.current.toggle(e);
                  oh?.current?.hide();
                }
              }}
            >
              <img src={homeLens} alt='lens-icon' />
            </Link>
            <span>Lens!</span>
            <p>Revolutionize Your Photo Editing Experience.</p>
            <OverlayPanel ref={overlayLens} className='lens-overlay'>
              <div className='lens-overlay-wrap'>
                <ul className='lens-overlay-list'>
                  {similarImagesObject?.permissions && <li>
                    <Link to="#" className={currLens === "Similar Images" ? "active-lens" : ""} onClick={() => handleCurrentLens("Similar Images")}>
                      <img src={lensImage} alt='bot-icon' />
                      <span>Similar Image</span>
                    </Link>
                  </li>}
                  {smartBackgroundObject?.permissions && <li>
                    <Link to="#" className={currLens === "Smart Background" ? "active-lens" : ""} onClick={() => handleCurrentLens("Smart Background")}>
                      <img src={lensSmartBack} alt='lens-icon' />
                      <span>Smart Background</span>
                    </Link>
                  </li>}
                  {generateInstanceObject?.permissions && <li>
                    <Link to="#" className={currLens === "Generate Instance" ? "active-lens" : ""} onClick={() => handleCurrentLens("Generate Instance")}>
                      <img src={lensAi} alt='lens-icon' />
                      <span>Generate Instance</span>
                    </Link>
                  </li>}
                  {imageExtenderObject?.permissions && <li>
                    <Link to="#" className={currLens === "Image Extender" ? "active-lens" : ""} onClick={() => handleCurrentLens("Image Extender")}>
                      <img src={imageExpansion} alt='lens-icon' />
                      <span>Image Extender</span>
                    </Link>
                  </li>}
                  {imageComparisionObject?.permissions &&
                    <li onClick={() => handleCompareImage("Image Comparison")}>
                      <Link to="#" className={currLens === "Image Comparison" ? "active-lens" : ""}>
                        <img src={imageCompare} alt='lens-icon' />
                        <span>Image Comparison</span>
                      </Link>
                    </li>
                  }
                </ul>
              </div>
            </OverlayPanel>
          </li>
        }
      </ul>);
    } else if (RON === 'solution') {
      return (
        <>
          <ul className='home-content-list marketing-section'>
            {emailGenerationObject?.permissions && <li>
              <Link to="#" className={currentActive === 'generateEmail' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("generateEmail")); dispatch(setCurrLens("")); }}>
                <img src={generateEmailIcon} alt='qmate-icon' />
              </Link>
              <span className=''>Generate<br />Email</span>
              {/* <p>Get instant answers from your enterprise data.</p> */}
            </li>}
            {postGenerationObject?.permissions && <li>
              <Link to="#" className={currentActive === 'generatePost' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("generatePost")); dispatch(setCurrLens("")); }}>
                <img src={generatePostIcon} alt='qmate-icon' />
              </Link>
              <span className=''>Generate<br />Social Post</span>
              {/* <p>Get instant answers from your enterprise data.</p> */}
            </li>}
            {articleGenerationObject?.permissions && <li>
              <Link to="#" className={currentActive === 'generateArticle' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("generateArticle")); dispatch(setCurrLens("")); }}>
                <img src={generateArticleIcon} alt='qmate-icon' />
              </Link>
              <span className=''>Generate<br />Article</span>
              {/* <p>Get instant answers from your enterprise data.</p> */}
            </li>}
            {ideaGenerationObject?.permissions && <li>
              <Link to="#" className={currentActive === 'generateIdea' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("generateIdea")); dispatch(setCurrLens("")); }}>
                <img src={generateIdeaIcon} alt='qmate-icon' />
              </Link>
              <span className=''>Generate<br />Idea</span>
              {/* <p>Get instant answers from your enterprise data.</p> */}
            </li>}
            {productDesGenerationObject?.permissions && <li>
              <Link to="#" className={currentActive === 'generateProduct' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("generateProduct")); dispatch(setCurrLens("")); }}>
                <img src={generateProductIcon} alt='qmate-icon' />
              </Link>
              <span className=''>Generate<br />Product Description</span>
              {/* <p>Get instant answers from your enterprise data.</p> */}
            </li>}
            {sentimentAnalysisObject?.permissions &&
              <li>
                <Link to="#" className={currentActive === 'sentimentAnalysis' ? 'home-content-active' : ""} onClick={() => { dispatch(handleActive("sentimentAnalysis")); }}>
                  <img src={generateSentimentAnalysisIcon} alt='qmate-icon' />
                </Link>
                <span className=''>Generate Sentiment Analysis</span>
              </li>
            }
          </ul>
          <div className="market-row">
            <div className='market-row-wrap'>
              {(currentActive === 'generateEmail' || currentActive === 'generateArticle') &&
                <div className='voice-filter-col  mt-1 mb-3 generation-dropdown'>
                  <FloatLabel>
                    <Dropdown inputId="dd-role" value={roleDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleRole(e.value))} options={connectorsListRole} optionLabel="name"
                      className="outline-select w-full" />
                    <label className="w-full text-sm" htmlFor="dd-role">Select Role</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                <div className='voice-filter-col  mt-1 mb-3 generation-dropdown'>
                  {/* <span className='text-sm' >Tone: </span> */}
                  <FloatLabel>
                    <Dropdown inputId="dd-tone" value={toneDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleTone(e.value))} options={connectorsListTone} optionLabel="name"
                      className="outline-select w-full" />
                    <label className="text-sm" htmlFor="dd-tone">Select Tone</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct' || currentActive === 'generateArticle') &&
                <div className='voice-filter-col  mt-1 mb-1 generation-dropdown'>
                  <FloatLabel>
                    <Dropdown inputId="dd-style" value={styleDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleStyle(e.value))} options={connectorsListStyle} optionLabel="name"
                      className="outline-select w-full" />
                    <label className='text-sm' htmlFor="dd-style">Select Style</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generateEmail' || currentActive === 'generateArticle') &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-length' value={lengthDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleLength(e.value))} options={connectorsListLength} optionLabel="name"
                      className="outline-select w-full" />
                    <label className='text-sm' htmlFor='dd-length' >Select Length</label>
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateEmail' &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-complexity' value={complexityDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleComplexity(e.value))} options={connectorsListComplexity} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-complexity' className='text-sm' >Select Complexity</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-age' value={ageRangeDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleAgeRange(e.value))} options={connectorsListAgeRange} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-age' className='text-sm' >Select Age Range</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generatePost' || currentActive === 'generateIdea') &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-objective' value={objectiveDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleObjective(e.value))} options={connectorsListObjective} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-objective' className='text-sm' >Select Objective</label>
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generatePost' &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-platform' value={platformDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handlePlatform(e.value))} options={connectorsListPlatform} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-platform' className='text-sm' >Select Platform</label>
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateProduct' &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-channel' value={channelDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleChannel(e.value))} options={connectorsListChannel} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-channel' className='text-sm' >Select Channel</label>
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateIdea' &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-desired' value={desiredOutcomeDropDown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleDesiredOutcome(e.value))} options={connectorsListDesiredOutcome} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-desired' className='text-sm' >Select Desired Outcome</label>
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateIdea' &&
                <div className='voice-filter-col  generation-dropdown mt-1 mb-1'>
                  <FloatLabel>
                    <Dropdown inputId='dd-constraint' value={constraintsDropdown} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => dispatch(handleConstraints(e.value))} options={connectorsListConstraints} optionLabel="name"
                      className="outline-select w-full" />
                    <label htmlFor='dd-constraint' className='text-sm' >Select Constraint</label>
                  </FloatLabel>
                </div>
              }
              {(currentActive === 'generateEmail' || currentActive === 'generatePost' || currentActive === 'generateProduct') &&
                <div className='mt-1 mb-4 voice-filter-col  generation-dropdown  text-sm'>
                  <FloatLabel>
                    <label className='text-sm' htmlFor="key">Keywords</label>
                    <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: '230px' }} className='radius-input ms-2' placeholder='Enter Keyword' value={keywords} onChange={(e) => dispatch(handleKeywords(e.target.value))} />
                  </FloatLabel>
                </div>
              }
              {/* {currentActive === 'generateProduct' &&
              <div className='mt-1 mb-4 voice-filter-col generation-dropdown  text-sm'>
                <FloatLabel>
                  <label className='text-sm' htmlFor="key">Key Feature</label>
                  <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none" }} className='radius-input ms-2' placeholder='Enter Key Feature' value={key_features} onChange={(e) => dispatch(handleKeyFeatures(e.target.value))} />
                </FloatLabel>
              </div>
            } */}
              {currentActive === 'generateProduct' &&
                <div className='mt-1 mb-4 voice-filter-col generation-dropdown  text-sm'>
                  <FloatLabel>
                    <label className='text-sm' htmlFor="key">Product Name</label>
                    <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: '230px' }} className='radius-input ms-2' placeholder='Enter Product Name' value={product_name} onChange={(e) => dispatch(handleProductName(e.target.value))} />
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateArticle' &&
                <div className='mt-1 mb-4  voice-filter-col generation-dropdown  text-sm'>
                  <FloatLabel>
                    <label className='text-sm' htmlFor="key">Purpose:</label>
                    <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: '230px' }} className='radius-input ms-2' placeholder='Enter Purpose' value={purpose} onChange={(e) => dispatch(handlePurpose(e.target.value))} />
                  </FloatLabel>
                </div>
              }
              {currentActive === 'generateArticle' &&
                <div className='mt-1 mb-4 voice-filter-col generation-dropdown   text-sm'>
                  <FloatLabel>
                    <label className='text-sm' htmlFor="key">Topic:</label>
                    <InputText style={{ borderRadius: "20px", height: "36px", boxShadow: "none", border: "none", width: '230px' }} className='radius-input ms-2' placeholder='Enter Topic' value={topic} onChange={(e) => dispatch(handleTopic(e.target.value))} />
                  </FloatLabel>
                </div>
              }
            </div>
          </div>
          <div className='d-flex justify-content-between'>
          </div>
        </>
      );
    }
    else if (RON === 'shopmate' && booleanArray2 !== 1) {
      return (
        <div className="shopmate-intro-wrap">
          <div className="shopmate-left">
            <div className='left-top-head'>
              <h1>Explore our AI-powered solutions.</h1>
              <h2>Elevate Customer Service with AI</h2>
              <p>Transform your e-commerce experience with intelligent AI assistance that understands, engages, and converts.
              </p>
            </div>
            <ul className="shopmate-box-listing">
              <li>
                <div className="shopmate-box">
                  <i><img src={shCart} alt='sh-cart' /></i>
                  <strong>AI Shopping Assistant</strong>
                </div>
              </li>
              <li>
                <div className="shopmate-box">
                  <i><img src={shDashboard} alt='sh-dashboard' /></i>
                  <strong>Analytics Dashboard</strong>
                </div>
              </li>
              <li>
                <div className="shopmate-box" style={{ cursor: 'pointer' }} onClick={handlePlaciFyCall}>
                  <i><img src={shChat} alt='sh-chat' /></i>
                  <strong>AI Experience</strong>
                </div>
              </li>
              <li>
                <div className="shopmate-box">
                  <i><img src={shInstant} alt='sh-instant' /></i>
                  <strong>Instant Recommendations</strong>
                </div>
              </li>
            </ul>
            <div className="shopmate-start-box">
              <p>Start a conversation with our AI assistant and see the magic happen in real-time!</p>
              <a onClick={handleChatBot} className='glow-btn'>Get Started</a>
            </div>
          </div>
          <div className="shopmate-right">
            <div className="shopmate-right-box">
              {placiFyOpen && <button type='button' className="placify-close-button" onClick={() => closePlaciFy()}>
                <i className="pi pi-times" style={{ fontSize: "22px" }}></i>
              </button>}
              {placiFyOpen
                ? <PlaciFy ref={placiFyRef} />
                : <DotLottieReact src="https://lottie.host/ca345f54-edef-4e3e-969f-09ddf22403ed/lhMJAfHeGf.json" width='540px' height='550px' loop autoplay />}
            </div>
          </div>
        </div>
        // <ul className='home-content-list single-menu'>
        //   <li>
        //     <div className='single-menu-wrap'>
        //       <i><img src={homeShopmate} alt='qmate-icon' /></i>
        //       <div className='right-menu-desc'>
        //         <strong>ShopMate!</strong>
        //         <p>Elevate customer service with Ron! ShopMate!</p>
        //       </div>
        //     </div>
        //   </li>
        // </ul>
      );
    }
  };

  const handlePlaciFyCall = () => {
    setPlaciFyOpen(true);
  };

  const closePlaciFy = () => {
    if (placiFyRef.current) {
      placiFyRef.current.disconnect();
    }
    setPlaciFyOpen(false);
  };

  return (
    <>
      <div className='home-content' onClick={() => overlayLens?.current?.hide()}>
        <div className={`${currentActive !== "shopmate" ? 'home-content-wrap' : ''} ${currentActive === 'voice' ? 'voice-content-wrap' : ''}`}>
          <div className='text-center'>
            {currentActive !== "shopmate"
              &&
              <h1>Explore our AI-powered {solutions()}.</h1>
            }
          </div>
          {booleanArray === 1 && RON === "product" && localStorage.getItem('clientName') !== 'Amspec_clone' && <ul className='home-content-list single-menu'>
            <li>
              <div className='single-menu-wrap'>
                <i><img src={imageSrc()} alt='qmate-icon' /></i>
                {imageSrcName()}
              </div>
            </li>
          </ul>}
          {localStorage.getItem('clientName') === 'Amspec_clone' &&
            <ul className='home-content-list single-menu'>
              <li>
                <div className='single-menu-wrap'>
                  <i><img src={homeQmate} alt='qmate-icon' /></i>
                  <div className='right-menu-desc'>
                    <strong>QMate!</strong>
                    <p>Get instant answers from your enterprise data.</p>
                  </div>
                </div>
              </li>
            </ul>
          }
          {booleanArray2 === 1 && currentActive === "shopmate" && RON === "shopmate" &&
            <div className="shopmate-intro-wrap">
              <div className="shopmate-left">
                <div className='left-top-head'>
                  <h1>Explore our AI-powered solutions.</h1>
                  <h2>Elevate Customer Service with AI</h2>
                  <p>Transform your e-commerce experience with intelligent AI assistance that understands, engages, and converts.
                  </p>
                </div>
                <ul className="shopmate-box-listing">
                  <li>
                    <div className="shopmate-box">
                      <i><img src={shCart} alt='sh-cart' /></i>
                      <strong>AI Shopping Assistant</strong>
                    </div>
                  </li>
                  <li>
                    <div className="shopmate-box">
                      <i><img src={shDashboard} alt='sh-dashboard' /></i>
                      <strong>Analytics Dashboard</strong>
                    </div>
                  </li>
                  <li>
                    <div className="shopmate-box" style={{ cursor: 'pointer' }} onClick={handlePlaciFyCall}>
                      <i><img src={shChat} alt='sh-chat' /></i>
                      <strong>AI Experience</strong>
                    </div>
                  </li>
                  <li>
                    <div className="shopmate-box">
                      <i><img src={shInstant} alt='sh-instant' /></i>
                      <strong>Instant Recommendations</strong>
                    </div>
                  </li>
                </ul>
                <div className="shopmate-start-box">
                  <p>Start a conversation with our AI assistant and see the magic happen in real-time!</p>
                  <a onClick={handleChatBot} className='glow-btn'>Get Started</a>
                </div>
              </div>
              <div className="shopmate-right">
                <div className="shopmate-right-box">
                  {placiFyOpen && <button type='button' className="placify-close-button" onClick={() => closePlaciFy()}>
                    <i className="pi pi-times" style={{ fontSize: "22px" }}></i>
                  </button>}
                  {placiFyOpen
                    ? <PlaciFy ref={placiFyRef} />
                    : <DotLottieReact src="https://lottie.host/ca345f54-edef-4e3e-969f-09ddf22403ed/lhMJAfHeGf.json" width='540px' height='550px' loop autoplay />}
                </div>
              </div>
            </div>
          }
          {handleFinalFunction()}
          {currentActive === "qmate" &&
            <>
              <div className='home-search'>
                <InputTextarea id='qmate' style={{ cursor: "auto" }} onKeyDown={(e) => handleEnterPressed(e)} autoResize={!isKeyDown ? true : false} value={qmate} className={`radius-input input-box ${isKeyDown ? 'input-animation' : ''
                  }`} onChange={handleInputChange} placeholder='Ask me anything' />
                {/* <InputTextarea style={{ cursor: "auto" }} id='home' onKeyDown={(e) => handleEnterPressed(e)} autoResize={!isKeyDown ? true : false} value={qmate} className={`radius-input input-box ${isKeyDown ? 'input-animation' : ''
                  }`} onChange={handleInputChange} placeholder='Ask me anything' /> */}
                <i className='sec-last-icon' style={{ opacity: (qmate === "" || qmate === "Listening..." || qmate.trim() === "") ? "0.5" : "", pointerEvents: (qmate === "" || qmate === "Listening..." || qmate.trim() === "") ? "none" : "visible" }} onClick={handleSendQueryButton} id='send-button'><img src={searchSend} alt='send-btn' /></i>
                {(VoiceSearchFlag === true || VoiceSearchFlag === undefined) && (
                  <i className='last-icon'><img src={qmate === "Listening..." ? searchMicActive : searchMic} onClick={handleVoiceIconClicked} alt='mic-btn' title='Search via Voice' /></i>
                )}
              </div>
              <div className='suggested-que'>
                <div className='suggested-que-heading'>
                  <strong>To begin with, you can also try the following examples:</strong>
                </div>
                <ul className='suggested-que-list'>
                  {defaultQuestions?.map((i: string, index: number) => (
                    <li key={index} onClick={() => handleDefaultQuestions(i)}>
                      <Link to="">{i}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          }
          {currentActive === 'documate' && <>
            <div className='home-search' onClick={handleButtonClick}>
              <InputText className='radius-input c-pointer' placeholder='Upload Document' readOnly />
              <i className='last-icon'><img src={uploadIcon} alt='upload-btn' /></i>
            </div>
            <input id='uploadDoc' ref={fileInputRef} type="file" placeholder='Upload document' onChange={handleBrowseFiles} className="d-none" accept='application/pdf' name="fileUpload" />
            <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Only PDF files with a maximum file size limit of <b>10 MB</b>.</p>
          </>}
          {currentActive === "voice" && <>
            <div className='voice-search'>
              <div className='home-search' style={{ pointerEvents: localStorage.getItem("clientName") !== 'Veedalifescience' ? 'visible' : 'none' }} onClick={handleVoiceToggle}>
                <InputText className='radius-input c-pointer' placeholder='Upload voice file' readOnly />
                <i className='last-icon'><img src={uploadIcon} alt='upload-btn' /></i>
              </div>
              <input id='uploadDoc' ref={voiceInputRef} type="file" placeholder='Upload document' className="d-none" accept=".mp3,.wav,.ogg,.aac" name="fileUpload" onChange={handleVoiceChange} />
              <Button label="List View" outlined icon="pi pi-list" className='btn-voice-list outline-icon-btn' onClick={() => navigate("/voice")} />
            </div>
            <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i><b>File formats:</b> .mp3, .wav, .aac, .ogg with a maximum file size limit of <b>5 MB</b>.</p>
          </>}
          {/* {currentActive === "bot" &&
            <ChatBox chatHeight={false} isPreview={"nopreview"} botName={""} tagline={""} initialMessage={""} botLogo={""} headerColor={""} answerBackgroundColor={""} questionBackgroundColor={""} avatarLogo={""} fontSize={12} />
          } */}
          {currentActive === "shopmate" &&
            <ChatBox chatHeight={false} isPreview={"nopreview"} botName={""} tagline={""} initialMessage={""} botLogo={""} headerColor={""} answerBackgroundColor={""} questionBackgroundColor={""} avatarLogo={""} fontSize={12} />
          }
          {currentActive === "lens" && currLens !== "" && <>
            <div className='type-image'><i><img src={handleCurrentLensImage()} alt='upload-btn' /></i>{currLens}</div>
            <div className='home-search' onClick={handleLensToggle}>
              <InputText className='radius-input c-pointer' placeholder='Upload Image' readOnly />
              <i className='last-icon'><img src={uploadIcon} alt='upload-btn' /></i>
            </div>
            <input id='uploadDoc' ref={lensInputRef} type="file" placeholder='Upload document' onChange={handleLensChange} className="d-none" accept=".jpg,.png,.webp,.jpeg" name="fileUpload" />
            <p className='helper-text'><i><img src={uploadImage} alt='qmate-icon' /></i><b>File formats:</b> .jpg, .png, .webp with a maximum file size limit of <b>10 MB</b>.</p>
          </>}
          {(RON === "solution" && currentActive !== "sentimentAnalysis") &&
            <>
              <div className='home-search'>
                <InputTextarea style={{ cursor: "auto" }} id='emailgen' onKeyDown={(e) => handleEnterPressedEmail(e)} autoResize={!isKeyDown ? true : false} value={emailGen} className={`radius-input input-box ${isKeyDown ? 'input-animation' : ''
                  }`} onChange={handleInputChangeEmail} placeholder='Ask me anything' />
                <i className='sec-last-icon' style={{ opacity: emailGen.trim() === "" ? "0.5" : "", pointerEvents: emailGen.trim() === "" ? "none" : "visible" }} onClick={handleSendQueryButtonEmail} id='send-button'><img src={searchSend} alt='send-btn' /></i>
                {(VoiceSearchFlag === true || VoiceSearchFlag === undefined) && (
                  <i className='last-icon'><img src={qmate === "Listening..." ? searchMicActive : searchMic} onClick={handleVoiceIconClickedGeneration} alt='mic-btn' title='Search via Voice' /></i>
                )}
              </div>
              {/* <div className='suggested-que'>
                <div className='suggested-que-heading'>
                  <strong>To begin with, you can also try the following examples:</strong>
                </div>
                <ul className='suggested-que-list'>
                  {defaultQuestions?.map((i: string, index: number) => (
                    <li key={index} onClick={() => handleDefaultQuestions(i)}>
                      <Link to="">{i}</Link>
                    </li>
                  ))}
                </ul>
              </div> */}
            </>
          }
          {currentActive === 'sentimentAnalysis' && <>
            <div className='home-search' onClick={handleSentimentAnalysisClick}>
              <InputText className='radius-input c-pointer' placeholder='Upload Document' readOnly />
              <i className='last-icon'><img src={uploadIcon} alt='upload-btn' /></i>
            </div>
            <input id='uploadDoc' ref={fileSentimentInputRef} type="file" placeholder='Upload document' onChange={handleSentimentBrowseFiles} className="d-none" accept='application/pdf' name="fileUpload" />
            <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Only PDF files with a maximum file size limit of <b>10 MB</b>.</p>
          </>}
        </div>
      </div>
      {/* <div className='home-footer'>
        <div className='home-footer-container'>
          <div className='home-footer-wrap'>
            <p>Ron! uses AI. Check for mistakes..</p>
            <ul className='footer-links'>
              <li>
                <Link to="#">Privacy Policy</Link>
              </li>
              <li>
                <Link to="#">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="#">FAQs</Link>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Home;